import { CheckCircle2, MapPin } from "lucide-react";

import { Badge } from "~/components/ui/badge";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/components/ui/card";

import { TIER_LABELS, type TierInfo } from "./types";

export function CurrentTierCard({
  currentTier,
  tierInfo,
}: {
  currentTier: string;
  tierInfo: TierInfo;
}) {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle className="flex items-center gap-2">
              <CheckCircle2 className="size-5" />
              Current Plan
            </CardTitle>
            <CardDescription>
              Your current billing tier and processing rate
            </CardDescription>
          </div>
          <Badge
            className={currentTier === "free" ? "" : "bg-success"}
            variant={currentTier === "free" ? "secondary" : "default"}
          >
            {TIER_LABELS[currentTier] ?? currentTier}
          </Badge>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <div className="bg-card rounded-lg border p-4 text-center">
            <p className="text-muted-foreground mb-1 text-sm">
              Processing Rate
            </p>
            <p className="text-3xl font-bold tabular-nums">
              {tierInfo.processingRate}%
            </p>
            <p className="text-muted-foreground text-xs">per transaction</p>
          </div>
          <div className="bg-card rounded-lg border p-4 text-center">
            <p className="text-muted-foreground mb-1 text-sm">Locations</p>
            <p className="flex items-center justify-center gap-1 text-3xl font-bold tabular-nums">
              <MapPin className="text-primary size-5" />
              {tierInfo.locationCount}
            </p>
            <p className="text-muted-foreground text-xs">active restaurants</p>
          </div>
          <div className="bg-card rounded-lg border p-4 text-center">
            <p className="text-muted-foreground mb-1 text-sm">Monthly Cost</p>
            <p className="text-3xl font-bold">
              {currentTier === "free" ? "$0" : "Per location"}
            </p>
            <p className="text-muted-foreground text-xs">
              {currentTier === "free"
                ? "pay only processing fees"
                : "based on location count"}
            </p>
          </div>
        </div>

        {tierInfo.betaPricingLocked && (
          <div className="bg-muted mt-4 rounded-lg p-3">
            <p className="text-muted-foreground text-sm">
              Beta pricing locked in. Your rate is grandfathered for early
              adoption.
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
